/* eslint-disable react-hooks/exhaustive-deps */
import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'

import useFilter from './hooks/useFilter.js'

const FormElectricChargingTime = ({initialSearch, onChange, overlayContentRef, type, withLabel = true, wrapper}) => {
  const {domain, i18n} = useContext(Context)
  const {filters, value} = useFilter({search: initialSearch, type})

  const config = domain.get('config')

  const {FILTERS_GROUPS_LABELS} = config.get('filtersLabels')
  const {FILTERS_GROUPS_IDS} = config.get('filtersGroups')
  const {DEFAULT_FILTERS_SEARCH} = config.get('searchFilters')

  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const handleChange = ({name, value: [currentValue]}) => {
    onChange(null, {
      field: name,
      lastFilter: TRACKING_FILTER_NAMES[name].TO,
      value: {
        from: null,
        to: currentValue && currentValue !== filterWrapperBasicAllSelectionsId && Number(currentValue)
      }
    })
  }

  const handleReset = ({filters}) => {
    const [filterName] = filters
    onChange(null, {
      field: filterName,
      value: DEFAULT_FILTERS_SEARCH[filterName]
    })
  }

  return (
    <FilterWrapperBasic
      filters={filters}
      group={FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID}
      legend={i18n.t(FILTERS_GROUPS_LABELS[FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID])}
      onChange={handleChange}
      onReset={handleReset}
      overlayContentRef={overlayContentRef}
      showLegend={withLabel}
      value={value}
      wrapper={wrapper}
    />
  )
}

FormElectricChargingTime.displayName = 'FormElectricChargingTime'
FormElectricChargingTime.propTypes = {
  initialSearch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormElectricChargingTime
